export const formControlLengths = [
  "1x",
  "2x",
  "3x",
  "4x",
  "6x",
  "8x",
  "full-size",
] as const

export type FormControlLength = (typeof formControlLengths)[number]

/** Shared width scale for fields and their controls. */
export const formControlLengthClasses: Record<FormControlLength, string> = {
  "1x": "w-(--form-control-length-1x) shrink-0",
  "2x": "w-(--form-control-length-2x) shrink-0",
  "3x": "w-(--form-control-length-3x) shrink-0",
  "4x": "w-(--form-control-length-4x) shrink-0",
  "6x": "w-(--form-control-length-6x) shrink-0",
  "8x": "w-(--form-control-length-8x) shrink-0",
  "full-size": "w-full min-w-0 shrink",
}
